// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    '../../app/models/MabinsoModel'
], (Globals, $, _, MabinsoModel) => {
    const Model = MabinsoModel.extend({
        urlRoot: Globals.baseUrl + 'interfaces/category',
        defaults: {
        },
        initialize() {
        },
        validate() {
        },
        get(key) {
            const that = this;
            const getValue = key2 => {
                const value = MabinsoModel.prototype.get.call(that, key2);
                if (key === 'name') {
                    return _.toName(value);
                }
                return value;
            };

            if (key.charAt(0) === '_') {
                key = key.substring(1);
                return $._(getValue(key));
            }
            return getValue(key);
        }
    });
    return Model;
});



// WEBPACK FOOTER //
// ./src/components/interface/models/InterfaceCategoryModel.js